import styled from 'styled-components'

export const AdditionalAction = styled.div`
  color: ${props => props.theme.linkColor};
  text-align: center;
  font-size: 16px;
  cursor: pointer;
`
